import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CookiePolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 text-white relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-400/20 blur-3xl rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-400/20 blur-3xl rounded-full"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 py-10">

        {/* HEADER */}
        <div className="text-center mb-10">
          <h1 className="text-4xl sm:text-5xl font-bold">
            Cookie Policy
          </h1>
          <p className="text-white/80 mt-2">
            AICA HEALTH — Cookies & Tracking Notice
          </p>
        </div>

        {/* CONTENT CARD */}
        <div className="bg-white/10 border border-white/20 rounded-2xl p-6 sm:p-8 backdrop-blur-xl shadow-lg space-y-6">

          <p className="text-white/80 whitespace-pre-line leading-relaxed">

AICA HEALTH

may use cookies and similar technologies to:

● improve user experience,
● analyze usage patterns,
● maintain sessions,
● enhance platform functionality,
● improve security,
● support analytics.

Cookies may include:

● essential cookies,
● analytics cookies,
● performance cookies,
● session cookies.

Users may disable cookies through browser settings; however, certain Platform features may not function properly.

Third-party analytics or service providers may also utilize cookies subject to their own policies.

          </p>

        </div>

        {/* FOOTER */}
        <div className="mt-12 flex items-center justify-between border-t border-white/20 pt-6">

          <p className="text-white/70 text-sm">
            © {new Date().toLocaleFullYear?.() || new Date().getFullYear()} AICA HEALTH TECH Pvt Ltd
          </p>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-5 py-2 bg-white text-teal-700 font-semibold rounded-xl shadow hover:bg-gray-200 transition"
          >
            <ArrowLeft size={18} />
            Go Back
          </button>

        </div>

      </div>
    </div>
  );
};

export default CookiePolicy;